module.exports = __webpack_public_path__ + "media/images/Desktop-Extension 2-238ea30c1c5104ef39d9338fb125bed7.png";